<template>
    <div class="clickatell-credentials-form">
        <text-input class="clickatell-credentials-form__text-input" type="text"
            placeholder="Integration ID" label="Integration ID" :required="true" :numeric="false"
            v-model="model.integrationId" :rules="[nonEmptyRule]" />
        <text-input class="clickatell-credentials-form__text-input" type="text"
            placeholder="API Key" label="API Key" :required="true" :numeric="false"
            v-model="model.apiKey" :rules="[nonEmptyRule]" />
        <text-input class="clickatell-credentials-form__text-input" type="text"
            placeholder="Telephone Number" label="WhatsApp Telephone Number" :required="true" :numeric="false"
            v-model="model.phone" :rules="[phoneRule]" />
    </div>
</template>

<script>
import TextInput from "@/components/inputs/TextInput";

export default {
    name: "ClickatellCredentialsForm",
    components: { TextInput },

    props: {
        value: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            model: { ...this.value }
        }
    },

    computed: {
        allValid() {
            return !!this.model.integrationId?.trim()
                && !!this.model.apiKey?.trim()
                && !!this.model.phone?.trim();
        }
    },

    watch: {
        model: {
            deep: true,
            handler(v) {
                this.$emit('input', { ...v });
            }
        },
        allValid: {
            immediate: true,
            handler(v) {
                this.$emit('valid', v);
            }
        }
    },

    methods: {
        nonEmptyRule(value) {
            return (value && value.trim().length > 0) ? true : "Required";
        },

        phoneRule(value) {
            return (value && value.trim().length > 0) ? true : "Required";
        }
    }
}
</script>

<style scoped lang="sass">
.clickatell-credentials-form
    display: flex
    flex-direction: column
    row-gap: 5px

    &__text-input
        height: 80px

    ::v-deep input
        width: 80%
</style>
